




import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { Record } from '@/domains/work';
import { Load } from '@/domains/system';
import { Page } from '@/domains/page';
import { isNullOrUndefined } from 'util';

import { export_json_to_excel } from '@/vendor/Export2Excel';
import { Template, Question, Option } from '@/domains/template';
import { listRecordTemplateApi } from '@/api/work/RecordApi';
import TheoryTemplateExcelUtil from '@/utils/excel/template/TheoryTemplateExcelUtil';
import TheoryTemplateExcelUtil2 from '@/utils/excel/template/TheoryTemplateExcelUtil2';
import TheoryTemplateExcelUtil3 from '@/utils/excel/template/TheoryTemplateExcelUtil3';
import ExperimentalTemplateExcelUtil from '@/utils/excel/template/ExperimentalTemplateExcelUtil';
import ExperimentalTemplateExcelUtil2 from '@/utils/excel/template/ExperimentalTemplateExcelUtil2';

@Component
export default class RecordTemplateExportExcelButton extends Vue {
  /** 导出 */
  private static export(datas: Record[]) {
    Load.startFullLoad('正在导出督导列表');

    const records: Record[][] = [];
    records[0] = [];
    records[1] = [];
    records[2] = [];
    records[3] = [];
    records[4] = [];

    datas.forEach((data: Record) => {
      records[data.template.id - 1].push(data);
    });
    datas = null;

    if (records[0].length > 0) {
      TheoryTemplateExcelUtil.exportExcel(records[0]);
    }
    if (records[1].length > 0) {
      ExperimentalTemplateExcelUtil.exportExcel(records[1]);
    }
    if (records[2].length > 0) {
      TheoryTemplateExcelUtil2.exportExcel(records[2]);
    }
    if (records[3].length > 0) {
      ExperimentalTemplateExcelUtil2.exportExcel(records[3]);
    }
    if (records[4].length > 0) {
      TheoryTemplateExcelUtil3.exportExcel(records[4]);
    }

    Load.stopFullLoad();
  }

  /** 计划 */
  @Prop()
  private form: Record;

  @Prop()
  private datas: Record[];

  /** 点击 */
  private click() {
    this.search().then((datas: Record[]) => {
      RecordTemplateExportExcelButton.export(datas);
    });
  }

  /** 查询 */
  private search(): Promise<Record[]> {
    return new Promise((resolve, reject) => {
      if (!this.rules()) {
        reject();
        return;
      }
      Load.startFullLoad('正在获取听课档案，请稍等。');
      listRecordTemplateApi(this.getParam()).then((result: any) => {
        const list: Record[] = Record.builds(result);
        resolve(list);
        Load.stopFullLoad();
      }).catch(() => {
        reject();
        Load.stopFullLoad();
      });
    });
  }

  /** 获取参数 */
  private getParam(): Record {
    let param: Record;
    if (this.datas.length === 0) {
      param = Record.build(this.form);
      param.pageInfo = new Page();
      param.pageInfo.pageNum = 1;
      param.pageInfo.pageSize = 200000;
    } else {
      param = new Record();
      const idList: number[] = [];
      this.datas.forEach((record: Record) => {
        idList.push(record.id);
      });
      param.idList = idList;
      param.template = new Template();
    }
    return param;
  }

  /** 校验 */
  private rules(): boolean {
    let result: boolean = true;
    if (isNullOrUndefined(this.form.plan.supervisor.person.id)
      && isNullOrUndefined(this.form.plan.supervisor.supervisorGroup.id)
      && (isNullOrUndefined(this.form.idList) || this.form.idList.length === 0)) {
      this.createRuleFailNotify('未获取到督导信息，请稍后再试。');
      result = false;
    }
    return result;
  }

  /** 创建参数错误通知 */
  private createRuleFailNotify(message: string) {
    this.$notify.error({ title: '参数错误！', message });
  }
}
